import { mergeClassName as e } from "../../utils/data.js";
import { ButtonIcon as t } from "../Button/ButtonIcon.js";
import n from "./Calendar.module.js";
import { DayButton as r } from "../../node_modules/react-day-picker/dist/esm/components/DayButton.js";
import { getDefaultClassNames as i } from "../../node_modules/react-day-picker/dist/esm/helpers/getDefaultClassNames.js";
import { DayPicker as a } from "../../node_modules/react-day-picker/dist/esm/DayPicker.js";
import '../../assets/node_modules/@daypicker/react/dist/style.css';/* empty css                                             */
import { createContext as o, useContext as s, useMemo as c } from "react";
import { Fragment as l, jsxDEV as u } from "react/jsx-dev-runtime";
import { CaretLeftIcon as d, CaretRightIcon as f } from "@phosphor-icons/react";
//#region lib/components/DatePicker/DayCalendar.tsx
var p = "/opt/render/project/src/shared-ui/lib/components/DatePicker/DayCalendar.tsx", m = o(void 0);
function h({ orientation: e, disabled: t }) {
	return /* @__PURE__ */ u(e === "left" ? d : f, {
		size: 24,
		"aria-hidden": !0,
		opacity: t ? .4 : 1
	}, void 0, !1, {
		fileName: p,
		lineNumber: 42,
		columnNumber: 12
	}, this);
}
function g({ children: e }) {
	let t = s(m);
	return /* @__PURE__ */ u("button", {
		type: "button",
		className: n.captionButton,
		onClick: t,
		children: e
	}, void 0, !1, {
		fileName: p,
		lineNumber: 48,
		columnNumber: 9
	}, this);
}
function _({ modifiers: t, className: i, ...a }) {
	let o = t.range_start || t.range_middle || t.range_end;
	return /* @__PURE__ */ u(r, {
		...a,
		modifiers: t,
		className: e(i, t.today && !t.selected && n.dayToday, t.selected && !o && n.daySelected)
	}, void 0, !1, {
		fileName: p,
		lineNumber: 62,
		columnNumber: 9
	}, this);
}
function v({ ...e }) {
	return /* @__PURE__ */ u(t, {
		...e,
		icon: /* @__PURE__ */ u(l, {}, void 0, !1, {
			fileName: p,
			lineNumber: 76,
			columnNumber: 38
		}, this),
		shape: "pill",
		color: "neutral",
		style: {
			width: "40px",
			height: "40px"
		}
	}, void 0, !1, {
		fileName: p,
		lineNumber: 76,
		columnNumber: 9
	}, this);
}
var y = {
	Chevron: h,
	CaptionLabel: g,
	DayButton: _,
	NextMonthButton: v,
	PreviousMonthButton: v
};
function b(t) {
	let { mode: r, selected: o, onSelect: s, numberOfMonths: l = 1, month: d, onMonthChange: f, onCaptionClick: h, className: g, constraints: _ } = t, { timeZone: v, noonSafe: b, disabledDates: x, hiddenDates: S, startMonth: C, endMonth: w, today: T, minDays: E, maxDays: D, excludeDisabled: O } = _ ?? {}, k = i(), A = {
		animate: !0,
		fixedWeeks: !0,
		navLayout: "around",
		numberOfMonths: l,
		month: d,
		onMonthChange: f,
		classNames: c(() => ({
			...k,
			root: e(k.root, n.rdpRoot, g),
			weekday: e(k.weekday, n.weekday),
			day_button: e(k.day_button, n.dayButton)
		}), [g, k]),
		components: y,
		timeZone: v,
		noonSafe: b,
		disabled: x,
		hidden: S,
		startMonth: C,
		endMonth: w,
		today: T
	};
	return r === "single" ? /* @__PURE__ */ u(m.Provider, {
		value: h,
		children: /* @__PURE__ */ u(a, {
			...A,
			mode: "single",
			selected: o,
			onSelect: (e) => {
				s(e);
			}
		}, void 0, !1, {
			fileName: p,
			lineNumber: 148,
			columnNumber: 17
		}, this)
	}, void 0, !1, {
		fileName: p,
		lineNumber: 147,
		columnNumber: 13
	}, this) : /* @__PURE__ */ u(m.Provider, {
		value: h,
		children: /* @__PURE__ */ u(a, {
			...A,
			mode: "range",
			min: E,
			max: D,
			excludeDisabled: O,
			selected: o,
			onSelect: (e) => {
				s(e);
			}
		}, void 0, !1, {
			fileName: p,
			lineNumber: 162,
			columnNumber: 13
		}, this)
	}, void 0, !1, {
		fileName: p,
		lineNumber: 161,
		columnNumber: 9
	}, this);
}
//#endregion
export { b as DayCalendar };
